import {IOccupationProfile} from './i-occupation-profile';
import {MultiLanguageString} from './multi-language-string';
import {VdabSpecific} from './vdab-specific';
import {TechnicalCompetence} from './technical-competence';
import {SoftSkill} from './soft-skill';

export class OccupationalProfile {
    constructor(public id: string,
                public vdabSpecific: VdabSpecific,
                public title?: MultiLanguageString,
                public description?: MultiLanguageString,
                public essentialCompetences?: Array<TechnicalCompetence>,
                public optionalCompetences?: Array<TechnicalCompetence>,
                public softSkills?: Array<SoftSkill>) {
    }

    public static fromInterface(iOP: IOccupationProfile): OccupationalProfile {
        return new OccupationalProfile(iOP.id,
			VdabSpecific.fromInterface(iOP.vdabSpecific),
            MultiLanguageString.fromInterface(iOP.title),
            MultiLanguageString.fromInterface(iOP.description),
            iOP.essentialCompetences && iOP.essentialCompetences.map(iCompetence => TechnicalCompetence.fromInterface(iCompetence)),
            iOP.optionalCompetences && iOP.optionalCompetences.map(iCompetence => TechnicalCompetence.fromInterface(iCompetence)),
            iOP.softSkills && iOP.softSkills.map(iSoftSkill => SoftSkill.fromInterface(iSoftSkill)));
    }

    public getInfoDomains(): string {
        return this.vdabSpecific.jobCategories.map(jobCategory => jobCategory.label).join(', ');
    }

    public hasMultipleDomains(): boolean {
        return this.vdabSpecific.jobCategories.length > 1;
    }

    public hasMonitoringCode(): boolean {
        return !!this.getFirstValidMonitoringCode();
    }

    public getFirstValidMonitoringCode(): string {
        return this.vdabSpecific.externalCodes
            .filter(externalCode => externalCode.type === 'MonitoringOccupationCode')
            .map(externalCode => externalCode.value)[0];
    }

}
